import { Time, TimePickerProps } from '../typings'
import { useCallback } from 'react'

export function useValidate(props: TimePickerProps) {
  const {
    required,
    validate = () => undefined,
    requiredErrorText = 'Required',
    invalidErrorText = 'Invalid format',
  } = props

  return useCallback(
    (time: Time | string) => {
      if (time === null && required) return requiredErrorText
      if (typeof time === 'string') return invalidErrorText

      return validate(time)
    },
    [invalidErrorText, required, requiredErrorText, validate],
  )
}
